import React from 'react';
import classes from "./football.module.css"
import VideoSection from '../../containers/videoSection/videoSection';
import WelcomeSection from '../welcomeSection/welcomeSection';
import Activities from '../activities/activities';
import Sessions from '../sessions/sessions';
import Background from '../../../assets/images/football-session.png';

const FootballCamp = (props) => {
  return (
    <div className={classes.Container}>
      {/* <VideoSection src="https://www.youtube.com/embed/YOUR_VIDEO_ID" /> */}
      <WelcomeSection title='WELCOME TO FOOTBALL CAMP' camp='football' info={props.footballCamp?.info} />
      <Activities title='FOOTBALL ACTIVITIES' activities={props.footballCamp?.activities} camp='football' />
      <Sessions title='FOOTBALL SESSIONS' offers={props.footballCamp?.packages} camp='football'
        extraServices={props.footballCamp?.extra_services}
        setSelectedPlan={props.setSelectedPlan}
        setShowCampRegistrationForm={props.setShowCampRegistrationForm}
        isAuthenticated={props.isAuthenticated} setShowLoginForm={props.setShowLoginForm}
        description={props.footballCamp?.info?.session_text} background={Background}/>
    </div>
  )
}
export default FootballCamp;